<!-- 后台会员系统起始页面 -->
<template>
  <div class="common">
    <head-logo />
    <Nev />
    <div class="main">
      <div class="center-box">
        <div class="fl nav-main">
          <div class="nav-title">
            会员中心
          </div>

          <ul class="nav-ul">
            <li
              v-for="(route, index) in routes"
              :key="route.path"
              @click="jumpTo(route.path, index + 1, route.meta.title)"
              :class="{ active: isActive == index + 1 }"
              v-if="!route.hidden"
            >
              {{ route.meta.title }}
            </li>
          </ul>
        </div>
        <div class="fr content-body">
          <!-- <h2 class="title">个人信息</h2> -->
          <router-view></router-view>
          <!-- <div class="mains"></div> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import HeadLogo from "./components/HeadLogo";
import Footer from "./components/Footer";
import Nev from "./components/Nev";
import { getSiteInfo } from "@/api/home";
import {
  getActive2,
  setActive2,
  removeActive2,
  getActiveName,
  setActiveName,
  removeActiveName,
  getToken,
  getUid,
} from "@/utils/auth";
import encrypt from "../utils/encrypt";
import { getStudentApplyTypeList } from "@/api/common";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { HeadLogo, Nev, Footer },
  data() {
    //这里存放数据
    return {
      isActive: 1,
      isOpen: false,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    routes() {
      console.log(this.$router.options)
      return this.$router.options.routes[0].children;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    jumpTo(val1, val2, val3) {
      this.$router.push({
        path: val1,
      });
      this.isOpen = false;
      this.isActive = val2;
      setActive2(val2);
      setActiveName(val3);
      this.$store.dispatch("user/setActive2", val3.toString());
    },
    fetchData() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getStudentApplyTypeList(params).then((response) => {
        this.dataList = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.isActive = getActive2();
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.common {
  width: 100%;
  height: 100%;
  background-color: #e1e1e1;

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .active {
    background-color: #007dc2;
    color: #ffffff !important;
  }
  .badge {
    // @media screen and (max-width: 1200px) {
    //   display: none;
    // }
    width: 100px;
    height: 100px;
    margin-right: 30px;
  }
  .main {
    width: 100%;
    min-height: 1100px;
    padding-top: 30px;
    padding-bottom: 75px;
    .fl {
      float: left;
    }
    .nav-main {
      @media screen and (max-width: 1010px) {
        display: none;
      }
      width: 225px;
      .nav-title {
        padding-left: 25px;
        width: 100%;
        text-align: left;
        height: 65px;
        line-height: 65px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        color: #ffffff;
        font-size: 22px;
        background-color: #01458e;
        margin-bottom: 10px;
      }
      .nav-ul {
        background-color: #ffffff;
        width: 100%;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        li {
          padding-left: 25px;
          width: 100%;
          font-size: 15px;
          color: #333333;
          height: 44px;
          line-height: 44px;
          cursor: pointer;
          border-bottom: 1px solid #ebebeb;
        }
      }
    }
    .fr {
      float: right;
    }
    .content-body {
      @media screen and (max-width: 1010px) {
        width: 100%;
      }
      overflow: auto;
      width: calc(100% - 255px);
      max-width: 950px;
      height: 1000px;
      background-color: #ffffff;
      border-radius: 12px;
      .title {
        padding-left: 37px;
        padding-right: 60px;
        font-size: 24px;
        color: #00468e;
        height: 75px;
        line-height: 75px;
        border-bottom: 1px solid #ebebeb;
      }
    }
  }
}
</style>
<style lang="scss">
.bm-menu {
  background-color: #00468e;
}
.bm-burger-bars {
  background-color: #ffffff;
}
.bm-burger-button {
  margin-top: 15px;
}
</style>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
